import {Collection} from '../../Common/stores/Collection';
import {TemplateField} from './TemplateField';

export class TemplateCollection extends Collection {
    insertFields(parentField, children) {
        this.fields.clear();
        children.forEach(f => {
            const newField = new TemplateField(f, parentField);
            newField.setCollection(f);
            this.fields.push(newField);
        });
    }
}
